import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';

/** Module */
export const LINK_EXPIRATION_MANAGEMENT_URL = '/linkExpirationManagement';

/** Search params */
export const SEARCH_PARAM_KEYS = {
  search: 'search',
};

export const SORTING_CONTEXT_INITIAL_STATE = {
  sortBy: 'projectName',
  sortDirection: SORT_DIRECTIONS.ASCENDING,
};

/** Form */
export const linksArrayName = 'links';
export const linksFormId = 'links-form';

export const LINK_ACTIONS = {
  customRedirect: 'CustomRedirect',
  terminate: 'Terminate',
} as const;

// values pulled from [this ticket](https://iterable.atlassian.net/browse/FRAM-6418)
export const DEFAULT_DATE_OPTIONS = [
  'Immediately',
  'May-2025',
  'August-2025',
  'November-2025',
  'February-2026',
  'February-2028',
];
